import type { FaqItem } from "@/components/shared/FAQ";
import type { HomeContent } from "../types";

export const ES_FAQS: FaqItem[] = [
  {
    question: "¿Puedo cancelar mi plan?",
    answer:
      "Sí. Puedes cancelar tu plan en cualquier momento desde la configuración. Tu plan seguirá activo hasta el final del ciclo de facturación.",
  },
  {
    question: "¿Qué es un crédito de flujo?",
    answer:
      "Un crédito de flujo equivale a un video generado por la IA de Crayo. Esto incluye AutoClip y otros flujos de trabajo.",
  },
  {
    question: "¿Cómo veo mi consumo?",
    answer:
      "Puedes ver tu consumo en la configuración. Haz clic en tu foto de perfil en la esquina superior derecha.",
  },
  {
    question: "¿Tienen política de reembolsos?",
    answer:
      "Lamentablemente no ofrecemos reembolsos. Puedes cancelar tu plan cuando quieras y seguirá activo hasta el final del ciclo de facturación.",
  },
  {
    question: "¿Qué es un minuto de exportación?",
    answer:
      "Un minuto de exportación es la duración de video que puedes generar con Crayo. Por ejemplo, con 60 minutos de exportación puedes generar un video de 1 minuto 60 veces.",
  },
  {
    question: "¿Puedo monetizar los videos creados con Crayo?",
    answer: "Sí. Los derechos de los videos que creas con Crayo son totalmente tuyos.",
  },
  {
    question: "¿Puedo generar en otros idiomas?",
    answer:
      "Sí. Soportamos la mayoría de los idiomas. Solo escribe el texto en el idioma en el que quieras generar. Contacta a soporte si necesitas un idioma que no esté disponible.",
  },
  {
    question: "¿Los créditos sin usar se acumulan?",
    answer:
      "Los créditos de la suscripción se renuevan cada mes en cualquier plazo del plan, ya pagues mensual, trimestral o anualmente, y los créditos sin usar no se acumulan. Los créditos de las recargas únicas son independientes de tu cuota mensual.",
  },
];

export const ES_HOME: HomeContent = {
  seoTitle: "Crayo: el editor de clips con IA",
  seoDescription:
    "Editor de video con IA para contenido corto. Cortar clips con IA, subtítulos automáticos, voces con IA y más. Recorta videos largos en shorts virales en segundos.",
  heading: {
    prefix: "La",
    highlight: "herramienta #1 para clipear",
    suffix: "Edita videos virales con IA",
  },
  body: "Tu herramienta todo en uno para cortar clips automáticamente, voces con IA, subtítulos que enganchan y más.",
  mobileBody: "Tu plataforma todo en uno para editar.",
  faqs: ES_FAQS,
};
